export default __webpack_public_path__ + "static/media/State Park Sign 1.71346654.jpg";